import React, { useCallback, useEffect, useMemo, useState } from 'react';

const links = [
  { href: '#about-me', label: 'About' },
  { href: '#skills-knowledge', label: 'Skills' },
  { href: '#case-studies', label: 'Work' },
  { href: '#experience-education', label: 'Experience' },
  { href: '#contact', label: 'Contact' }
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navId = useMemo(() => 'primary-navigation', []);

  const toggleMenu = useCallback(() => {
    setIsOpen(open => !open);
  }, []);

  const closeMenu = useCallback(() => {
    setIsOpen(false);
  }, []);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.body.classList.toggle('no-scroll', isOpen);
    }
  }, [isOpen]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <header className="site-header">
      <nav className="site-nav" aria-label="Primary navigation">
        <a className="nav-logo" href="#hero">
          RP
        </a>
        <button
          type="button"
          className="nav-toggle"
          aria-expanded={isOpen}
          aria-controls={navId}
          onClick={toggleMenu}
        >
          <span className="nav-toggle__label">Menu</span>
          <span className="nav-toggle__icon" aria-hidden="true" />
        </button>
        <ul id={navId} className={`menu ${isOpen ? 'menu--open' : ''}`}>
          {links.map(link => (
            <li key={link.href}>
              <a href={link.href} onClick={closeMenu}>
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;
